import { useContext } from 'react';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import ZoneContext from '@wix/da-gruser-shared/pkg/context/ZoneContext';
import { getExhibitionistWidgetType } from './helpers';
import { ExhibitionistWidgetType } from './types';
export const useExhibitionistType = ()=>{
    const zone = useContext(ZoneContext);
    const gruser = useContext(GruserContext);
    if (!gruser || !zone) {
        return ExhibitionistWidgetType.STRIP;
    }
    const exhibitionistType = getExhibitionistWidgetType({
        gruser,
        zone
    });
    return exhibitionistType;
};
